import React, {Component, Fragment} from 'react';
import {FormGroup, Input, Label,} from 'reactstrap';

import './RatingMultiResponse.scss';
import './RatingResponse.scss';
import Checkbox from '../../../../shared/forms/Checkbox';

class RatingMultiResponse extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isCommentOpened: false
    }
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    // Validate for case of edit
    if (this.props.value.rating) {
      this.handleCheckInput(this.props.value.rating);
    }

    this.setState({
      isCommentOpened: !!this.props.value.comment
    })
  }

  // ----------------------
  // Methods
  // ----------------------

  get isCommentRequired() {
    return (this.props.value.rating === 'unAcceptable' && this.props.reqiureUnacceptableComment)
  }

  isValid(comment, rating) {
    return (this.isCommentRequired ? !!comment: true) && rating !== null
  }

  handleCheckInput(type) {
    const { comment, timeSpend } = this.props.value;

    const valueObject = {
      isValid: this.isValid(comment, type),
      comment,
      rating: type,
      timeSpend
    };


    this.props.onValueChange(this.props.name, valueObject);
  }

  openComment() {
    this.setState({
      isCommentOpened: true
    })
  }

  handleCommentInput(value) {
    const {rating, timeSpend} = this.props.value;

    const valueObject = {
      isValid: this.isValid(value, rating),
      comment: value,
      rating,
      timeSpend
    };

    this.props.onValueChange(this.props.name, valueObject);
  }

  handleTimeSpendInput(value) {

    const valueObject = {
      ...this.props.value,
      timeSpend: value
    };

    this.props.onValueChange(this.props.name, valueObject);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="rating-response rating-multi-response">
        <Label>{this.props.ratingPrompt}</Label>
        <div className="rating-multi-fields-container">
          <div className="rating-multi-field">
            <div className="rating-check-container">
              <div className="rating-check">
                <Checkbox
                  label={this.props.acceptablePrompt || 'Acceptable'}
                  checked={this.props.value.rating === 'acceptable'}
                  onChange={() => {
                    return this.handleCheckInput('acceptable');
                  }}
                />
              </div>
              <div className="rating-check">
                <Checkbox
                  label={this.props.unAcceptablePrompt || 'Unacceptable'}
                  checked={this.props.value.rating === 'unAcceptable'}
                  onChange={() => {
                    return this.handleCheckInput('unAcceptable');
                  }}
                />
              </div>
            </div>
            {this.props.useNoNr && (
              <Fragment>
                <div className="rating-check-container">
                  <div className="rating-check">
                    <Checkbox
                      label={this.props.notObservedPrompt || 'Not observed'}
                      checked={this.props.value.rating === 'notObserved'}
                      onChange={() => {
                        return this.handleCheckInput('notObserved');
                      }}
                    />
                  </div>
                  <div className="rating-check">
                    <Checkbox
                      label={this.props.notResponsivePrompt || 'Not responsive'}
                      checked={this.props.value.rating === 'notResponsive'}
                      onChange={() => {
                        return this.handleCheckInput('notResponsive');
                      }}
                    />
                  </div>
                </div>
              </Fragment>
            )}
            {this.props.useNo && (
              <Fragment>
                <div className="rating-check-container">
                  <div className="rating-check">
                    <Checkbox
                      label={this.props.notObservedPrompt || 'Not observed'}
                      checked={this.props.value.rating === 'notObserved'}
                      onChange={() => {
                        return this.handleCheckInput('notObserved');
                      }}
                    />
                  </div>
                </div>
              </Fragment>
            )}
            {
              (this.props.value.rating !== null)
              && !this.state.isCommentOpened
              &&  (
              <div>
                <button className="button primary small" type="button" onClick={() => this.openComment()}>
                  <i className="fa fa-plus"></i>
                  <span>Add comment</span>
                </button>
              </div>
            ) || null}
          </div>

          {this.props.hasTimeSpendField && (
            <div style={{maxWidth: '600px', paddingTop: '15px'}}>
              <FormGroup>
                <label>
                  {this.props.timeSpendFieldPrompt || 'If remedial training occurred, list minutes spend'}
                </label>
                <Input
                  onBlur={event => this.handleTimeSpendInput(event.target.value)}
                  onChange={event => this.handleTimeSpendInput(event.target.value)}
                  type="text"
                  placeholder="Time spend"
                  value={this.props.value.timeSpend}
                />
              </FormGroup>
            </div>
          )}

          {
            (this.state.isCommentOpened || this.isCommentRequired) && (
              <div>
                {this.isCommentRequired && <div className="text-danger small">Comment is required</div>}
                <FormGroup>
                  <Input
                    className={(this.props.value.touched && !this.props.value.isValid) ? 'is-invalid' : ''}
                    onBlur={event => this.handleCommentInput(event.target.value, true)}
                    onChange={event => this.handleCommentInput(event.target.value)}
                    type="textarea"
                    placeholder="Comment"
                    value={this.props.value.comment}
                  />
                </FormGroup>
              </div>
            )

          }
        </div>
      </div>
    );
  }
}

export default RatingMultiResponse;

